import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { withRouter } from 'react-router'

import { EmptyDashboard } from '../../'
import styles from './dashboard-right.styl'
import config from 'config'

@withRouter
class DashboardRight extends Component {
  static propTypes = {
    children: PropTypes.any,
    isFetchingAward: PropTypes.bool,
    notApproved: PropTypes.bool,
    isAssessor: PropTypes.bool,
    match: PropTypes.object,
  }

  render() {
    const classNames = [styles.right]
    const { children, isAssessor, isFetchingAward, notApproved, match } = this.props

    if (get(match, 'path') === `${config.publicPath}/dashboard/awards/:awardId`
      && get(match, 'isExact') === true
      && !isAssessor) {
      return (
        <div className={classNames.join(' ')}>
          <EmptyDashboard
            isLoading={isFetchingAward}
            notApproved={notApproved}
          />
        </div>
      )
    }

    return <div className={classNames.join(' ')}>{children}</div>
  }
}

export default DashboardRight
